define('config/knockoutCustomisations',[],function() {

    return {

        // BINDINGS
        navBinding: {
            module: 'common/ko/customBinding/nav',
            init: 'partial',
            args: ['@context', '@settings', '@navigation'],
            extras: [{
                subscribe: 'beforeAppStart'
            }]
        },
        lazyForEachBinding: {
            module: 'common/ko/customBinding/lazyForeach',
            init: 'partial',
            extras: [{
                subscribe: 'beforeAppStart'
            }]
        },
        launchGameBinding: {
            module: 'ko/customBinding/launchGame',
            init: 'partial',
            args: [
                'LOG',
                '@googleTagManager',
                '@gameLauncher',
                '@session',
                '@GameMessagesHandler',
                'publish:handleNoLoggedOutFreeplay',
                'publish:handleNoLoggedInFreeplay',
                '@tournamentExcludedGameDialog'
            ],
            extras: [{
                subscribe: 'beforeAppStart'
            }]
        },
        vocaBinding: {
            module: 'common/ko/customBinding/voca',
            init: 'partial',
            args: ['@vocabulary'],
            extras: [{
                subscribe: 'beforeAppStart'
            }]
        },
        ifMediaBinding: {
            module: 'ko/customBinding/ifMedia',
            init: 'partial',
            args: ['@mediaResponder'],
            extras: [{
                subscribe: 'beforeAppStart'
            }]
        },
        imageBinding: {
            module: 'ko/customBinding/image',
            init: 'partial',
            args: ['@imageOptimizer', '@context'],
            extras: [{
                subscribe: 'beforeAppStart'
            }]
        },
        actionBinding: {
            module: 'ko/customBinding/action',
            init: 'partial',
            args: ['@actions'],
            extras: [{
                subscribe: 'beforeAppStart'
            }]
        },
        scrollContainerBinding: {
            module: 'ko/customBinding/scrollContainer',
            init: 'partial',
            args: ['@scrollManager'],
            extras: [{
                subscribe: 'beforeAppStart'
            }]
        },
        htmlBinding: {
            module: 'common/ko/customBinding/html',
            init: 'partial',
            args: ['LOG'],
            extras: [{
                subscribe: 'beforeAppStart'
            }]
        }
    };
});

